export default "__VITE_ASSET__046ffc69__"